import { render, staticRenderFns } from "./ProductVariantsManager.vue?vue&type=template&id=7667e3ae&scoped=true"
import script from "./ProductVariantsManager.vue?vue&type=script&lang=js"
export * from "./ProductVariantsManager.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantsManager.vue?vue&type=style&index=0&id=7667e3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7667e3ae",
  null
  
)

export default component.exports